import { isAltOrientation } from "./modules/grid";
import {
	EmberHSSTokenDocument,
	HSSToken,
	HSSTokenDocument,
	SimpleVistaHSSTokenDocument,
} from "./modules/mixins";
import { finalizeMigration, registerSettings } from "./modules/settings";
import { extendPrototypeTokenConfig, extendTokenConfig } from "./modules/token-config";

Hooks.once("init", () => {
	console.log("hex-size-support | Initializing module");
	CONFIG.Token.documentClass = HSSTokenDocument(CONFIG.Token.documentClass);
	CONFIG.Token.objectClass = HSSToken(CONFIG.Token.objectClass);
	if (game.modules.get("ember")?.active)
		CONFIG.Token.documentClass = EmberHSSTokenDocument(CONFIG.Token.documentClass);
	if (game.modules.get("simple-vistas")?.active)
		CONFIG.Token.documentClass = SimpleVistaHSSTokenDocument(CONFIG.Token.documentClass);
	registerSettings();
	game.modules.get("hex-size-support").api = { isAltOrientation };
});

Hooks.once("ready", finalizeMigration);

Hooks.on("renderTokenConfig", extendTokenConfig);
Hooks.on("renderPrototypeTokenConfig", extendPrototypeTokenConfig);

const refreshTokenState = c => c.token?.object?.renderFlags.set({ refreshState: true });
Hooks.on("createCombatant", refreshTokenState);
Hooks.on("deleteCombatant", refreshTokenState);
Hooks.on("deleteCombat", combat => {
	for (const combatant of combat.combatants) refreshTokenState(combatant);
});
